import { getSection } from '../redux/actions/section-actions';

export default {
  actions: { getSection },
};
